<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    enable-background="new 0 0 21 21"
    xml:space="preserve"
  >
    <g id="icon">
      <path
        d="M2.5,2.5v4M6.5,6.5H2.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <line
        x1="10.5"
        y1="5"
        x2="10.5"
        y2="10.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <line
        x1="10.5"
        y1="10.5"
        x2="14.45"
        y2="14.45"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M3.1,6.094C4.649,3.578,7.428,1.9,10.6,1.9c4.86,0,8.8,3.94,8.8,8.8s-3.94,8.8,-8.8,8.8s-8.8,-3.94,-8.8,-8.8"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
